export const COLORS = {
  // colors from Audi color palette
  // https://react.ui.audi/?path=/story/brand-identity-colors--page
  white: '#ffffff',
  black: '#000000',
  grey5: '#f2f2f2',
  grey10: '#e5e5e5',
  grey15: '#d9d9d9',
  grey20: '#cccccc',
  grey30: '#b3b3b3',
  grey40: '#999999',
  grey50: '#808080',
  grey60: '#666666',
  grey70: '#4c4c4c',
  grey80: '#333333',
  grey90: '#1a1a1a',
  // new colors
  audiRed: '#f50537',
  skeletonColor: 'rgba(0, 0, 0, 0.05)',
  highlightColor: '#f5f5f5',
  atomic: '#434c53',
  alabaster: '#f8f8f8',
  whisper: '#e9e9e9',
  pinkSwan: '#b7b7b7',
  wildSand: '#f6f6f6',
  shiraz: '#bb0a30',
  redRibbon: '#EB0D3F',
  flashOfOrange: '#FFAA00',
  spaceInvader: '#0DA20D',
  error: '#EB0D3F',
  menuBorder: '#B9B9B9',
  menuBackground: '#E1E1E1',
  menuTextColor: '#222222',
};

type ColorKeys = keyof typeof COLORS;

export type Color = (typeof COLORS)[ColorKeys];

export const SIZING = {
  unit: (times: number): string => `${times * 8}px`,
};
